import { apiGET, apiPUT } from './api';

export const getSystemSettings = () => apiGET('/system_settings');

export const updateSystemSettings = systemSettings => apiPUT('/system_settings', systemSettings);
